var map = {
	"./certified_refurbished_datacenter_hardware.webp": 134,
	"./choose_right_hardware.webp": 5253,
	"./colocation_benefits.webp": 4874,
	"./colocation_cost_guide.webp": 8116,
	"./colocation_vs_cloud_hosting.webp": 6694,
	"./colocation_vs_dedicated.webp": 7911,
	"./data_center_tier_levels_explained.webp": 2148,
	"./datacenter_hardware_validation_test_cases.webp": 39,
	"./how_to_choose_colocation_provider.webp": 6654,
	"./it_knowledgebase_better_operations.webp": 9897,
	"./optimize_IT_Infrastructure.webp": 1685,
	"./preventive_management.webp": 8442,
	"./rigorous_testing_refurbished_it_equipment.webp": 9448,
	"./smart_it_investment_refurbished_hardware.webp": 3180,
	"./sustainable_datacenter_hardware.webp": 3120,
	"./vps_vs_dedicated_server.webp": 3349
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1364;